<div mat-dialog-content style="width: 100%; height: 100%">
    <button
        type="button"
        class="close-btn"
        data-dismiss="modal"
        (click)="closeDialog()"
        aria-label="Close"
    >
        <span aria-hidden="true">&times;</span>
    </button>

    <div class="row" style="height: 100%">
        <div class="col-6" style="height: 100%">
            <h1 mat-dialog-title style="color: #5f6369; font-size: 16px">
                Change Summary ({{ this.modifiedCount }})
            </h1>
            <ul
                style="
                    background: #f3f3f4;
                    height: 90%;
                    border-radius: 10px;
                    overflow-y: auto;
                    padding: 2%;
                    list-style-type: none;
                "
            >
                <li
                    *ngFor="let props of this.ModifiedSettings"
                    style="padding: 10px"
                >
                    <div
                        style="
                            padding: 10px;
                            margin-bottom: 5px;
                            font-size: 20px;
                            font-weight: bold;
                        "
                    >
                        <fa-icon [icon]="props.tab.icon"></fa-icon>
                        {{ props.tab.title }}
                    </div>
                    <ul
                        *ngFor="let group of props.groups"
                        style="list-style: none"
                    >
                        <li
                            style="
                                padding: 5px;
                                margin-bottom: 5px;
                                font-size: 16px;
                                font-weight: bold;
                            "
                        >
                            {{ group.group.title }}
                        </li>
                        <div
                            *ngFor="let property of group.initialValues"
                            style="margin-top: 10px; margin-bottom: 10px"
                        >
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="resetProp(property.propertyName)"
                                style="margin-top: 10px; float: right"
                            >
                                <fa-icon
                                    [icon]="faTimes"
                                    style="
                                        border: 1px solid #d00e0e;
                                        background-color: #d00e0e;
                                        color: white;
                                        font-size: 10px;
                                        font-weight: bold;
                                        display: inline-block;
                                        border-radius: 60px;
                                        box-shadow: 0 0 2px #888;
                                        padding: 0.1em 0.3em;
                                    "
                                ></fa-icon>
                            </button>
                            <div
                                style="
                                    background: white;
                                    border-radius: 10px;
                                    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
                                    height: 55px;
                                    width: 90%;
                                    align-content: center;
                                "
                            >
                                <mat-generic-form-field-disabled
                                    [property]="property"
                                    [manualRefresh]="manualRefresh"
                                    [disabled]="true"
                                >
                                </mat-generic-form-field-disabled>
                            </div>
                        </div>
                        <br />
                    </ul>
                </li>
            </ul>
        </div>
        <div class="col-6" style="height: 100%">
            <!--vertical align div using flexbox-->

            <div
                style="
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    height: 100%;
                "
            >
                <div style="max-width: 50%">
                    <h1
                        mat-dialog-title
                        style="color: #5f6369; font-size: 24px"
                    >
                        Apply to
                    </h1>

                    <div *ngIf="!this.userId">
                        <mat-form-field
                            class="mask"
                            appearance="fill"
                            style="width: 200%; margin-bottom: 10%"
                                        
                        >
                            <mat-label>Select</mat-label>
                            <mat-select
                                [value]="updateType"
                                (selectionChange)="onTypeChange($event)"
                                        [disabled]="!isSiteAdmin"
                            >
                                <mat-option value="Organization"
                                    >Organisation</mat-option
                                >
                                <mat-option value="Role">Role</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field
                            class="mask"
                            appearance="fill"
                            style="width: 200%; margin-bottom: 10%"
                            *ngIf="updateType == 'Organization'"
                                        
                        >
                            <mat-label>Select organisation</mat-label>
                            <mat-select
                                [value]="selectedOrganizationId"
                                (selectionChange)="onOrganizationChange($event)"
                                        [disabled]="!isSiteAdmin"
                            >
                                <mat-option
                                    *ngFor="let o of this.organizations"
                                    [value]="o.CompanyId"
                                    >{{ o.Name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field
                            class="mask"
                            appearance="fill"
                            style="width: 200%; margin-bottom: 10%"
                            *ngIf="updateType == 'Role' && isSiteAdmin"

                        >
                            <mat-label>Select role</mat-label>
                            <mat-select
                                [value]="selectedRoleId"
                                (selectionChange)="onRoleChange($event)"
                            >
                                <mat-option
                                    *ngFor="let o of this.roles"
                                    [value]="o.ID"
                                    >{{ o.RoleName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div *ngIf="this.userId">
                        <mat-form-field
                            appearance="fill"
                            style="width: 200%; margin-bottom: 10%"
                        >
                            <input
                                [readonly]="true"
                                disabled
                                type="text"
                                matInput
                                placeholder="User"
                                [value]="this.userName"
                            />
                        </mat-form-field>
                    </div>

                    <div class="row" style="width: 200%; margin-bottom: 10%">
                        <div class="col-12">
                            <button
                                class="btn rounded-pill"
                                style="
                                    color: black;
                                    background: white;
                                    border: 1px solid black;
                                    margin-right: 10px;
                                    width: 160px;
                                    height: 40px;
                                "
                                (click)="closeDialog()"
                            >
                                Cancel
                            </button>
                            <button
                                class="btn default-success rounded-pill"
                                style="width: 160px; height: 40px"
                                (click)="onSuccessClick()"
                            >
                                Apply changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
